<template>
    <section class="menu-view">
        <HeaderComponent :title="'Cardápio'" />
        <div class="menu-container">
            <h1>Selecione o restaurante:</h1>

            <div class="search">
                <input type="text" placeholder="Buscar" v-model="searchText" @input="filterItems" />
                <i class="fa fa-search icon"></i>
            </div>

            <div v-if="loading" class="loading">
                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
            <div class="list" v-else-if="restaurantsFiltered.length > 0">
                <div class="list-item" v-for="(restaurant, key) in restaurantsFiltered" :key="key" @click="goToRestaurantMenu(restaurant)">
                    <div class="list-item-field">
                        <h1 v-text="restaurant.NMFILIAL"></h1>
                    </div>
                    <div class="list-item-field">
                        <i class="fa fa-chevron-right icon"></i>
                    </div>
                </div>
            </div>
            <div class="not-found" v-else>
                Não foram encontrados resultados
            </div>
        </div>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import { getMenuRestaurants, getRestaurantGroups } from '@/components/controllers/MenuController.js'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'MenuView',
    components: {
        HeaderComponent
    },
    data () {
        return {
            searchText: '',
            restaurantsFiltered: [],
            loading: false
        }
    },
    computed: {
        ...mapGetters(['menuRestaurants'])
    },
    methods: {
        ...mapActions(['setCurrentRestaurant']),
        filterItems: function () {
            this.restaurantsFiltered = this.menuRestaurants.filter(restaurant => restaurant.NMFILIAL.toLowerCase().includes(this.searchText.toLowerCase()))
        },
        goToRestaurantMenu: function (restaurant) {
            this.setCurrentRestaurant(restaurant)
            getRestaurantGroups(
                restaurant.CDFILIAL,
                restaurant.CDLOJA,
                restaurant.NRCONFTELA
            ).then((res) => {
                this.$router.push({ name: 'RestaurantMenuView' })
            })
        }
    },
    mounted () {
        if (!this.menuRestaurants.length) {
            this.loading = true
            getMenuRestaurants().then((res) => {
                this.loading = false
                this.restaurantsFiltered = this.menuRestaurants
            })
        } else {
            this.restaurantsFiltered = this.menuRestaurants
        }
    }
}
</script>

<style lang="less" scoped>
.menu-container {
    h1 {
        font-weight: 600;
    }

    .search {
        display: flex;
        align-items: center;
        margin-top: 30px;
        // grey background
        background-color: #d9d9d963;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .list {
        height: calc(100vh - 170px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .list-item {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding: 20px 10px;
            border-bottom: solid #BAB8B8 2px;

            &:last-of-type {
                margin-bottom: 20px;
            }
        }
    }

    .not-found, .loading {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        h1 {
            font-weight: 600;
        }
    }
}

</style>
